import type { SolanaConverter } from '../../type'

const convertToActions: SolanaConverter = (_args) => {
  // TODO: 実装
  return undefined
}

export default convertToActions
